module.exports = __webpack_public_path__ + "assets/fbcdfd2b01f5b9eac3999f96576053d5.mp3";